/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions" endpoint.
 * Creates one action bank row. The body passes through the platform to Conman
 * unchanged, so Conman owns validation of the fields.
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys } from "./constants";
import type {
  DecisioningStudioActionBankWriteError,
  PostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys,
  createMutationFetcherFunctionWithShadowError<DecisioningStudioActionBankWriteError>()(
    (
      props: PostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsProps
    ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/dimensions/${props.dimension}/actions`,
        "POST",
        {
          fields: props.fields,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
